import { useQuery } from "@tanstack/react-query";
import type {
	MillSize,
	RollApplication,
	RollBlank,
	RollMaterial,
} from "../models/RollBlank";
import {
	getMillSizes,
	getRollApplications,
	getRollBlanks,
	getRollMaterials,
} from "../repositories/RollsBlankRepository";

export const ROLLS_BLANK_QUERY_KEYS = {
	all: ["rollsBlanks"] as const,
	list: () => ["rollsBlanks", "list"] as const,
	byId: (id: number | null) => ["rollsBlanks", "detail", id] as const,
	millSizes: ["rollsBlanks", "millSizes"] as const,
	rollApplications: ["rollsBlanks", "rollApplications"] as const,
	rollMaterials: ["rollsBlanks", "rollMaterials"] as const,
};

export const useRollsBlanks = () => {
	const query = useQuery<RollBlank[], Error>({
		queryKey: ROLLS_BLANK_QUERY_KEYS.list(),
		queryFn: () => getRollBlanks(),
	});

	return {
		rollBlanks: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};

export const useMillSizes = () => {
	return useQuery<MillSize[], Error>({
		queryKey: ROLLS_BLANK_QUERY_KEYS.millSizes,
		queryFn: getMillSizes,
		staleTime: 5 * 60 * 1000,
	});
};

export const useRollApplications = () => {
	return useQuery<RollApplication[], Error>({
		queryKey: ROLLS_BLANK_QUERY_KEYS.rollApplications,
		queryFn: getRollApplications,
		staleTime: 5 * 60 * 1000,
	});
};

export const useRollMaterials = () => {
	return useQuery<RollMaterial[], Error>({
		queryKey: ROLLS_BLANK_QUERY_KEYS.rollMaterials,
		queryFn: getRollMaterials,
		staleTime: 5 * 60 * 1000,
	});
};
